import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ECommerceComparisonTable() {
  const features = [{
    name: 'Products',
    silver: 'Unlimited',
    gold: 'Unlimited',
    platinum: 'Unlimited'
  }, {
    name: 'Product Search',
    silver: 'Basic search',
    gold: 'Advanced filters',
    platinum: 'AI-powered recommendations'
  }, {
    name: 'Discounts & Coupons',
    silver: 'Basic',
    gold: 'Advanced',
    platinum: 'Custom rules & automation'
  }, {
    name: 'Abandoned Cart',
    silver: false,
    gold: true,
    platinum: true
  }, {
    name: 'Analytics',
    silver: 'Google Analytics',
    gold: 'Enhanced e-commerce',
    platinum: 'Advanced custom reports'
  }, {
    name: 'Subscriptions',
    silver: false,
    gold: false,
    platinum: true
  }, {
    name: 'Gift Cards',
    silver: false,
    gold: false,
    platinum: true
  }, {
    name: 'Shipping & Tracking',
    silver: 'Basic',
    gold: 'Advanced',
    platinum: 'Custom & international'
  }, {
    name: 'Storage',
    silver: '5GB',
    gold: '10GB',
    platinum: '25GB+'
  }, {
    name: 'Training',
    silver: 'Documentation',
    gold: '1-to-1 session',
    platinum: 'Multiple sessions'
  }, {
    name: 'Custom Features',
    silver: false,
    gold: 'Limited',
    platinum: 'Extensive'
  }];
  return <motion.div initial={{
    opacity: 0,
    height: 0
  }} animate={{
    opacity: 1,
    height: 'auto'
  }} exit={{
    opacity: 0,
    height: 0
  }} transition={{
    duration: 0.4,
    ease: 'easeInOut'
  }} className="mt-8 overflow-x-auto" style={{
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
  }} data-id="element-1179">
      <table className="min-w-full bg-white dark:bg-[#1E1E1E] rounded-lg overflow-hidden border border-[#D7E0E7] dark:border-gray-700" data-id="element-1180">
        <thead className="bg-[#212C34]" data-id="element-1181">
          <tr data-id="element-1182">
            <th className="py-4 px-6 text-left font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" data-id="element-1183">
              Feature
            </th>
            <th className="py-4 px-6 text-center font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(234, 247, 250, 0.1)'
          }} data-id="element-1184">
              E-Silver (£838.80)
            </th>
            <th className="py-4 px-6 text-center font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(255, 246, 229, 0.1)'
          }} data-id="element-1185">
              E-Gold (£1,195.20)
            </th>
            <th className="py-4 px-6 text-center font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(243, 245, 246, 0.1)'
          }} data-id="element-1186">
              E-Platinum (£1,796.40)
            </th>
          </tr>
        </thead>
        <tbody data-id="element-1187">
          {features.map((feature, index) => <tr key={index} className="transition-colors duration-200 hover:bg-[#E8F8FB] dark:hover:bg-gray-800/50" style={{
          backgroundColor: index % 2 === 0 ? '#F9FAFB' : '#EDF1F3'
        }} data-id="element-1188">
              <td className="py-4 px-6 border-b border-[#D7E0E7] dark:border-gray-700 font-semibold text-gray-900 dark:text-gray-100" data-id="element-1189">
                {feature.name}
              </td>
              <td className="py-4 px-6 text-center border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(234, 247, 250, 0.3)'
          }} data-id="element-1190">
                {typeof feature.silver === 'boolean' ? feature.silver ? <CheckIcon size={20} className="text-green-500 mx-auto" data-id="element-1191" /> : <XIcon size={20} className="text-gray-400 mx-auto" data-id="element-1192" /> : <span className="text-gray-700 dark:text-gray-300 font-medium" data-id="element-1193">
                    {feature.silver}
                  </span>}
              </td>
              <td className="py-4 px-6 text-center border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(255, 246, 229, 0.4)'
          }} data-id="element-1194">
                {typeof feature.gold === 'boolean' ? feature.gold ? <CheckIcon size={20} className="text-green-500 mx-auto" data-id="element-1195" /> : <XIcon size={20} className="text-gray-400 mx-auto" data-id="element-1196" /> : <span className="text-gray-700 dark:text-gray-300 font-medium" data-id="element-1197">
                    {feature.gold}
                  </span>}
              </td>
              <td className="py-4 px-6 text-center border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(243, 245, 246, 0.5)'
          }} data-id="element-1198">
                {typeof feature.platinum === 'boolean' ? feature.platinum ? <CheckIcon size={20} className="text-green-500 mx-auto" data-id="element-1199" /> : <XIcon size={20} className="text-gray-400 mx-auto" data-id="element-1200" /> : <span className="text-gray-700 dark:text-gray-300 font-medium" data-id="element-1201">
                    {feature.platinum}
                  </span>}
              </td>
            </tr>)}
        </tbody>
      </table>
    </motion.div>;
}